export default "__VITE_ASSET__0Cjk0BHF__"